// Normaliza o valor apenas para comparar "antes x depois" (não altera o que é enviado à API)
const normalizeForCompare = (value) => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) {
    return JSON.stringify(value.map((item) => String(item?.id ?? item)).sort());
  }
  if (typeof value === 'object') return String(value.id ?? JSON.stringify(value));
  const text = String(value);
  // Data ISO com hora: compara só YYYY-MM-DD
  return /^\d{4}-\d{2}-\d{2}T/.test(text) ? text.slice(0, 10) : text;
};

export const isSameValue = (a, b) => normalizeForCompare(a) === normalizeForCompare(b);

// Retorna só os campos de `current` cujo valor difere de `original` (payload de PATCH)
export const pickChangedFields = (current, original = {}, keys = Object.keys(current)) => {
  const changed = {};
  keys.forEach((key) => {
    if (!isSameValue(current[key], original[key])) {
      changed[key] = current[key];
    }
  });
  return changed;
};
